$(() => {
    const
        $header = $('#header'),
        $navigation = $('#navigation'),
        prepareSticky = document.getElementById('header').offsetHeight,
        sticky = document.getElementById('mv').offsetHeight - (prepareSticky * 2);
    // Nav Fixed
    $(window).on('scroll', () => {
        // preparation for fixed header animation
        if ($(window).scrollTop() > prepareSticky) {
            $header.addClass('is-prepareSticky');
        } else {
            $header.removeClass('is-prepareSticky');
        }

        // show fixed header
        if ($(window).scrollTop() > sticky) {
            $header.addClass('is-sticky');
        } else {
            $header.removeClass('is-sticky');
        }
    });

    // Nav Toggle Button
    $('#nav-toggle').on('click', e => {
        $navigation.toggleClass('is-toggle');
        $('#nav-toggle').toggleClass('is-toggle');

        if ($(e.currentTarget).hasClass('is-toggle')) {
            $('body').css('overflow', 'hidden');
        } else {
            $('body').css('overflow', 'auto');
        }
    });
});

// headerの下線(ホバー時はホバー対象の下線、外れたらそのページメニューに下線)
$(() => {
    const $nav = $('.navigationList__item__link');
    const active = 'is-activeLine';

    // マウスイベントへの伝搬を止める
    $nav.bind('touchstart', e => {
        e.stopPropagation();
    });
    $nav.bind('touchend', e => {
        e.stopPropagation();
    });

    $nav.mouseenter(e => {
        $nav.removeClass(active);
        $(e.currentTarget).addClass(active);
    });
    $nav.mouseout(e => {
        $nav.removeClass(active);
        $('.is-activeTxt').addClass(active);
    });
});
